module.exports = __webpack_public_path__ + "static/media/card-pediatria.214025bb.svg";